import { ReactNode } from 'react';

type CollectionSocialMedias = {
    id: string;
    name: string;
    icon: ReactNode;
    link: string;
};

export const collectionSocialMedias: CollectionSocialMedias[] = [
    {
        id: 'whatsapp',
        name: 'WhatsApp',
        icon: (
            <svg
                width='32'
                height='32'
                viewBox='0 0 32 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M25.485 6.34383C26.688 7.55067 27.6185 8.9178 28.2764 10.4452C28.9343 11.9726 29.2632 13.566 29.2632 15.2254C29.2632 17.4882 28.6899 19.5813 27.5433 21.5047C26.3967 23.4281 24.8553 24.9556 22.9192 26.087C20.9831 27.2184 18.8873 27.7841 16.6316 27.7841C14.4887 27.7841 12.4963 27.2749 10.6542 26.2567L4 28.0104L5.80452 21.5047C4.67669 19.5813 4.11278 17.4882 4.11278 15.2254C4.11278 12.9626 4.67669 10.8695 5.80452 8.94608C6.93234 7.02268 8.4549 5.49528 10.3722 4.36387C12.2895 3.23245 14.376 2.66675 16.6316 2.66675C18.2857 2.66675 19.8741 2.98731 21.3967 3.62845C22.9192 4.26958 24.282 5.17471 25.485 6.34383ZM23.3097 18.2515L23.508 18.3842C23.8165 18.5168 23.9928 18.6273 24.0369 18.7157C24.0809 18.8042 24.092 19.0252 24.0699 19.3789C24.0479 19.7326 23.9598 20.0973 23.8055 20.4731C23.6513 20.8489 23.2987 21.2246 22.7478 21.6004C22.197 21.9762 21.7232 22.1862 21.3266 22.2304C20.7096 22.3188 20.1147 22.3188 19.5418 22.2304C18.8807 22.0978 17.9994 21.7883 16.8976 21.302C14.6501 20.3294 12.6008 18.5168 10.7499 15.8642L10.6177 15.7316C9.64818 14.3611 9.16342 13.1011 9.16342 11.9516C9.16342 10.8022 9.56004 9.80745 10.3533 8.96746L10.4194 8.90115C10.7279 8.59168 11.0584 8.43694 11.411 8.43694H12.2042C12.3805 8.43694 12.5237 8.4701 12.6339 8.53642C12.7441 8.60273 12.8432 8.76852 12.9314 9.03378L14.0551 11.7527C14.1873 12.0179 14.2094 12.239 14.1212 12.4158C13.9009 12.8579 13.6144 13.2558 13.2619 13.6095C13.0856 13.7863 12.9754 13.93 12.9314 14.0405C12.8873 14.1511 12.9314 14.2726 13.0636 14.4053C13.6805 15.5547 14.4077 16.461 15.245 17.1242C15.862 17.6105 16.7874 18.1631 18.0214 18.782C18.3739 18.9589 18.6384 18.9368 18.8146 18.7157C19.3875 18.0526 19.7842 17.5663 20.0045 17.2568C20.0927 17.08 20.2028 16.9916 20.335 16.9916C20.4672 16.9916 20.6215 17.0137 20.7978 17.0579C21.1503 17.1905 21.9876 17.5884 23.3097 18.2515Z'
                    fill='#00994F'
                />
            </svg>
        ),
        link: '',
    },
    {
        id: 'facebook',
        name: 'Facebook',
        icon: (
            <svg
                width='33'
                height='32'
                viewBox='0 0 33 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M28.3333 3.5H5.33325C4.78013 3.5 4.33325 3.94687 4.33325 4.5V27.5C4.33325 28.0531 4.78013 28.5 5.33325 28.5H28.3333C28.8864 28.5 29.3333 28.0531 29.3333 27.5V4.5C29.3333 3.94687 28.8864 3.5 28.3333 3.5ZM25.4458 10.7969H23.4489C21.8833 10.7969 21.5801 11.5406 21.5801 12.6344V15.0437H25.3176L24.8301 18.8156H21.5801V28.5H17.6833V18.8188H14.4239V15.0437H17.6833V12.2625C17.6833 9.03437 19.6551 7.275 22.5364 7.275C23.9176 7.275 25.102 7.37813 25.4489 7.425V10.7969H25.4458Z'
                    fill='#1877F2'
                />
            </svg>
        ),
        link: '',
    },
    // {
    //     id: 'instagram',
    //     icon: (
    //         <svg
    //             width='33'
    //             height='32'
    //             viewBox='0 0 33 32'
    //             fill='none'
    //             xmlns='http://www.w3.org/2000/svg'
    //         >
    //             <path
    //                 d='M21.1667 16.5C21.1667 17.2911 20.9322 18.0645 20.4926 18.7223C20.0531 19.3801 19.4284 19.8928 18.6975 20.1955C17.9666 20.4983 17.1623 20.5775 16.3864 20.4231C15.6105 20.2688 14.8977 19.8878 14.3383 19.3284C13.7789 18.769 13.3979 18.0563 13.2436 17.2804C13.0893 16.5044 13.1685 15.7002 13.4712 14.9693C13.774 14.2384 14.2867 13.6136 14.9445 13.1741C15.6023 12.7346 16.3756 12.5 17.1667 12.5C18.2266 12.5033 19.2421 12.9258 19.9915 13.6752C20.741 14.4246 21.1635 15.4401 21.1667 16.5ZM29.6667 11V22C29.6667 23.8565 28.9292 25.637 27.6165 26.9497C26.3037 28.2625 24.5233 29 22.6667 29H11.6667C9.81023 29 8.02976 28.2625 6.717 26.9497C5.40425 25.637 4.66675 23.8565 4.66675 22V11C4.66675 9.14348 5.40425 7.36301 6.717 6.05025C8.02976 4.7375 9.81023 4 11.6667 4H22.6667C24.5233 4 26.3037 4.7375 27.6165 6.05025C28.9292 7.36301 29.6667 9.14348 29.6667 11ZM23.1667 16.5C23.1667 15.3133 22.8149 14.1533 22.1556 13.1666C21.4963 12.1799 20.5592 11.4108 19.4628 10.9567C18.3665 10.5026 17.1601 10.3838 15.9962 10.6153C14.8323 10.8468 13.7632 11.4182 12.9241 12.2574C12.085 13.0965 11.5135 14.1656 11.282 15.3295C11.0505 16.4933 11.1693 17.6997 11.6235 18.7961C12.0776 19.8925 12.8466 20.8295 13.8333 21.4888C14.82 22.1481 15.9801 22.5 17.1667 22.5C18.758 22.5 20.2842 21.8679 21.4094 20.7426C22.5346 19.6174 23.1667 18.0913 23.1667 16.5ZM25.1667 10C25.1667 9.70333 25.0788 9.41332 24.914 9.16665C24.7491 8.91997 24.5149 8.72771 24.2408 8.61418C23.9667 8.50065 23.6651 8.47094 23.3741 8.52882C23.0831 8.5867 22.8159 8.72956 22.6061 8.93934C22.3963 9.14912 22.2534 9.41639 22.1956 9.70736C22.1377 9.99834 22.1674 10.2999 22.2809 10.574C22.3945 10.8481 22.5867 11.0824 22.8334 11.2472C23.0801 11.412 23.3701 11.5 23.6667 11.5C24.0646 11.5 24.4461 11.342 24.7274 11.0607C25.0087 10.7794 25.1667 10.3978 25.1667 10Z'
    //                 fill='url(#paint0_linear_8929_20949)'
    //             />
    //             <defs>
    //                 <linearGradient
    //                     id='paint0_linear_8929_20949'
    //                     x1='17.1667'
    //                     y1='4'
    //                     x2='17.1667'
    //                     y2='29'
    //                     gradientUnits='userSpaceOnUse'
    //                 >
    //                     <stop stop-color='#F9CE34' />
    //                     <stop offset='0.5' stop-color='#EE2A7B' />
    //                     <stop offset='1' stop-color='#6228D7' />
    //                 </linearGradient>
    //             </defs>
    //         </svg>
    //     ),
    //     link: '',
    // },
    {
        id: 'x',
        name: 'X',
        icon: (
            <svg
                width='33'
                height='32'
                viewBox='0 0 33 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M24.1885 5H28.0219L19.6469 14.5729L29.5 27.5969H21.7854L15.7437 19.6969L8.82917 27.5969H4.99375L13.9521 17.3573L4.5 5.00104H12.4104L17.8719 12.2219L24.1885 5ZM22.8438 25.3031H24.9677L11.2562 7.17396H8.97708L22.8438 25.3031Z'
                    fill='#14171A'
                />
            </svg>
        ),
        link: '',
    },
    {
        id: 'telegram',
        name: 'Telegram',
        icon: (
            <svg
                width='33'
                height='32'
                viewBox='0 0 33 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clip-path='url(#clip0_8929_20953)'>
                    <path
                        d='M16.3333 0C12.0908 0 8.01825 1.68675 5.02075 4.68625C2.02018 7.68696 0.334111 11.7565 0.333252 16C0.333252 20.2417 2.02075 24.3142 5.02075 27.3137C8.01825 30.3132 12.0908 32 16.3333 32C20.5758 32 24.6483 30.3132 27.6458 27.3137C30.6458 24.3142 32.3333 20.2417 32.3333 16C32.3333 11.7583 30.6458 7.68575 27.6458 4.68625C24.6483 1.68675 20.5758 0 16.3333 0Z'
                        fill='url(#paint0_linear_8929_20953)'
                    />
                    <path
                        d='M7.57636 15.8311C12.2414 13.7991 15.3514 12.4594 16.9064 11.8121C21.3514 9.96381 22.2739 9.64281 22.8764 9.63193C23.0089 9.62981 23.3039 9.66256 23.4964 9.81818C23.6564 9.94943 23.7014 10.1269 23.7239 10.2516C23.7439 10.3761 23.7714 10.6598 23.7489 10.8813C23.5089 13.4113 22.4664 19.5508 21.9364 22.3846C21.7139 23.5836 21.2714 23.9856 20.8439 24.0248C19.9139 24.1103 19.2089 23.4108 18.3089 22.8211C16.9014 21.8978 16.1064 21.3233 14.7389 20.4226C13.1589 19.3816 14.1839 18.8093 15.0839 17.8743C15.3189 17.6296 19.4139 13.9058 19.4914 13.5681C19.5014 13.5258 19.5114 13.3683 19.4164 13.2853C19.3239 13.2021 19.1864 13.2306 19.0864 13.2531C18.9439 13.2851 16.6964 14.7721 12.3364 17.7138C11.6989 18.1523 11.1214 18.3661 10.6014 18.3548C10.0314 18.3426 8.93136 18.0318 8.11386 17.7663C7.11386 17.4406 6.31636 17.2683 6.38636 16.7151C6.42136 16.4271 6.81886 16.1323 7.57636 15.8311Z'
                        fill='white'
                    />
                </g>
                <defs>
                    <linearGradient
                        id='paint0_linear_8929_20953'
                        x1='1600.33'
                        y1='0'
                        x2='1600.33'
                        y2='3200'
                        gradientUnits='userSpaceOnUse'
                    >
                        <stop stopColor='#2AABEE' />
                        <stop offset='1' stopColor='#229ED9' />
                    </linearGradient>
                    <clipPath id='clip0_8929_20953'>
                        <rect
                            width='32'
                            height='32'
                            fill='white'
                            transform='translate(0.333252)'
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        link: '',
    },
    // {
    //     id: 'tiktok',
    //     icon: (
    //         <svg
    //             width='33'
    //             height='32'
    //             viewBox='0 0 33 32'
    //             fill='none'
    //             xmlns='http://www.w3.org/2000/svg'
    //         >
    //             <path
    //                 d='M22.3 7.76C21.3888 6.71937 20.8866 5.3832 20.8867 4H16.7667V20.5333C16.7356 21.4283 16.3581 22.2761 15.7138 22.898C15.0695 23.5199 14.2088 23.8672 13.3134 23.8667C11.42 23.8667 9.84671 22.32 9.84671 20.4C9.84671 18.1067 12.06 16.3867 14.34 17.0933V12.88C9.74005 12.2667 5.71338 15.84 5.71338 20.4C5.71338 24.84 9.39338 28 13.3 28C17.4867 28 20.8867 24.6 20.8867 20.4V12.0133C22.5574 13.2131 24.5632 13.8569 26.62 13.8533V9.73333C26.62 9.73333 24.1134 9.85333 22.3 7.76Z'
    //                 fill='#010101'
    //             />
    //         </svg>
    //     ),
    //     link: '',
    // },
    {
        id: 'email',
        name: 'Email',
        icon: (
            <svg
                width='32'
                height='32'
                viewBox='0 0 32 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clip-path='url(#clip0_8929_20958)'>
                    <path
                        d='M5.2045 25.3798H9.18175V15.7207L3.5 11.4595V23.6753C3.5 24.6185 4.26425 25.3798 5.2045 25.3798Z'
                        fill='#4285F4'
                    />
                    <path
                        d='M22.8184 25.3797H26.7957C27.7389 25.3797 28.5002 24.6155 28.5002 23.6752V11.4592L22.8184 15.7206'
                        fill='#34A853'
                    />
                    <path
                        d='M22.8184 8.33423V15.7206L28.5002 11.4594V9.18635C28.5002 7.07848 26.094 5.87673 24.4094 7.14098'
                        fill='#FBBC04'
                    />
                    <path
                        d='M9.18164 15.7207V8.33448L15.9998 13.4479L22.8179 8.33423V15.7206L15.9998 20.8344'
                        fill='#EA4335'
                    />
                    <path
                        d='M3.5 9.1866V11.4593L9.18175 15.7207V8.33447L7.59087 7.14122C5.90337 5.87697 3.5 7.07872 3.5 9.1866Z'
                        fill='#C5221F'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_8929_20958'>
                        <rect width='32' height='32' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        ),
        link: '',
    },
];
